var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { AccordionItem as A11yAccordionItem, AccordionItemState as A11yAccordionItemState, } from 'react-accessible-accordion';
import AccordionItemHeader from './AccordionItemHeader';
import AccordionItemPanel from './AccordionItemPanel';
const AccordionItem = (_a) => {
    var { title, description, content, className, dangerouslySetTitle, taggingRegion, onClick, clickEventName, uuid } = _a, rest = __rest(_a, ["title", "description", "content", "className", "dangerouslySetTitle", "taggingRegion", "onClick", "clickEventName", "uuid"]);
    const { variant } = content;
    const [accordionItemUuid, setAccordionItemUuid] = React.useState(uuid !== null && uuid !== void 0 ? uuid : uuidv4());
    const ref = React.useRef(null);
    // The a11y accordion doesn't offer a way to close a panel through it's API.
    // But we are able to close the panel by changing its key
    const closePanel = () => {
        setAccordionItemUuid(uuidv4());
    };
    const handleClick = () => {
        var _a, _b;
        if (onClick) {
            onClick();
        }
        const name = clickEventName || `Accordion - ${(_a = ref.current) === null || _a === void 0 ? void 0 : _a.textContent}`;
        (_b = window.allytm) === null || _b === void 0 ? void 0 : _b.event('clickEvent', {
            name,
            tagName: 'div',
        });
    };
    return (React.createElement(A11yAccordionItem, { className: className, key: accordionItemUuid, uuid: accordionItemUuid },
        React.createElement(A11yAccordionItemState, null, ({ expanded: isExpanded }) => {
            return (React.createElement(React.Fragment, null,
                React.createElement(AccordionItemHeader, Object.assign({ variant: variant, title: title, description: description, dangerouslySetTitle: dangerouslySetTitle, ref: ref, isExpanded: Boolean(isExpanded), onClick: handleClick, "data-testid": `accordionItem-${accordionItemUuid}`, "data-track-elem": "accordion", "data-track-trigger": "statechange", "data-track-state": isExpanded ? 'opened' : 'closed', "data-track-name": title }, (taggingRegion
                    ? { 'data-track-region': taggingRegion }
                    : {}), rest)),
                React.createElement(AccordionItemPanel, { content: content, closePanel: closePanel, isExpanded: Boolean(isExpanded), uuid: accordionItemUuid })));
        })));
};
export default AccordionItem;
//# sourceMappingURL=AccordionItem.js.map